export const SITE_NAME = '一带一路见面会'

const WEB_CONFIG_KEY = 'web-config'
const WEB_CONFIG_V2_KEY = 'web-config:v2'

// 网站配置相关操作
export function getWebConfig() {
    const v2 = localStorage.getItem(WEB_CONFIG_V2_KEY)
    if (v2) {
        try {
            const parsed = JSON.parse(v2)
            if (parsed && typeof parsed === 'object' && parsed.data) return parsed.data
        } catch (e) {
            // ignore bad cache
        }
    }

    const webConfig = localStorage.getItem(WEB_CONFIG_KEY)
    if (!webConfig) return null
    try {
        return JSON.parse(webConfig)
    } catch (e) {
        return null
    }
}

export function setWebConfig(config) {
    // 兼容老数据（仍然写一份老key，避免其它地方直接读 key）
    localStorage.setItem(WEB_CONFIG_KEY, JSON.stringify(config))
    localStorage.setItem(
        WEB_CONFIG_V2_KEY,
        JSON.stringify({
            data: config,
            meta: {
                hash: stableHash(config),
                cachedAt: Date.now()
            }
        })
    )
}

export function getWebConfigMeta() {
    const v2 = localStorage.getItem(WEB_CONFIG_V2_KEY)
    if (!v2) return null
    try {
        const parsed = JSON.parse(v2)
        return parsed?.meta || null
    } catch (e) {
        return null
    }
}

export function isWebConfigChanged(oldConfig, newConfig) {
    return stableHash(oldConfig) !== stableHash(newConfig)
}

function stableHash(obj) {
    // 用稳定序列化生成可比对的hash（避免 key 顺序导致误判）
    return stableStringify(obj)
}

function stableStringify(value) {
    if (value === null) return 'null'
    const t = typeof value
    if (t === 'string') return JSON.stringify(value)
    if (t === 'number' || t === 'boolean') return String(value)
    if (Array.isArray(value)) return `[${value.map(stableStringify).join(',')}]`
    if (t !== 'object') return JSON.stringify(value)

    const keys = Object.keys(value).sort()
    return `{${keys.map((k) => `${JSON.stringify(k)}:${stableStringify(value[k])}`).join(',')}}`
}